import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";

const POSTS = [
  {
    id: 1,
    type: "brand",
    headline: "GPS METHOD™",
    subline: "A System for Psychological Presence",
    body: "Founded by Mel Masry",
    accent: "Professional Coaching School",
    bgImage: null,
    caption: `Introducing GPS Method™ — A System for Psychological Presence.\n\nFounded by Mel Masry, the GPS Method is a structured approach to actor training that goes beyond technique. It’s about building genuine internal presence — the kind audiences feel before you even speak.\n\nGrounding. Presence. Structure.\nThree pillars. One transformation.\n\nApplications now open — link in bio.`,
    hashtags: "#GPSMethod #ActorTraining #PsychologicalPresence #MelMasry #ActingSchool #MethodActing #PresenceWork #ActorsLife #PerformanceCoaching #TheGPSWay",
  },
  {
    id: 2,
    type: "quote",
    headline: "“Presence is not something you perform. It is something you inhabit.”",
    subline: "— Mel Masry",
    body: "Founder, GPS Method™",
    bgImage: "https://images.unsplash.com/photo-1571173069043-82a7a13cee9f?w=800&q=80",
    caption: `“Presence is not something you perform. It is something you inhabit.” — Mel Masry\n\nMost actors spend years learning how to appear present. The GPS Method teaches you how to actually BE present.\n\nThe difference? Your audience will feel it.\n\nDiscover the GPS Method — link in bio.`,
    hashtags: "#ActingQuotes #Presence #GPSMethod #MelMasry #ActorLife #StagePresence #ActingTips #PerformanceArt #TheatreLife #ActingInspiration",
  },
  {
    id: 3,
    type: "pillars",
    headline: "THE THREE PILLARS",
    pillars: [
      { letter: "G", word: "GROUNDING", desc: "Root into your body. Find your centre. Let the ground hold you." },
      { letter: "P", word: "PRESENCE", desc: "Arrive fully in the moment. No past. No future. Just now." },
      { letter: "S", word: "STRUCTURE", desc: "Build the internal architecture that supports authentic expression." },
    ],
    caption: `G • P • S\n\nGrounding. Presence. Structure.\n\nThese three pillars form the foundation of the GPS Method™ — a system designed to transform how actors prepare, perform, and connect.\n\n▪️ Grounding: Root into your body\n▪️ Presence: Arrive in the moment\n▪️ Structure: Build internal architecture\n\nWhich pillar resonates with you most? Drop a G, P, or S in the comments.\n\nLearn more — link in bio.`,
    hashtags: "#GPSMethod #Grounding #Presence #Structure #ActorTraining #ActingTechnique #PerformanceCoaching #MindBodyConnection #ActorsJourney #TheatreTraining",
  },
  {
    id: 4,
    type: "statement",
    headline: "STOP ACTING.",
    subline: "START BEING.",
    body: "The shift that changes everything.",
    bgImage: "https://images.unsplash.com/photo-1624897459868-3e1b02fc1d0c?w=800&q=80",
    caption: `Stop acting. Start being.\n\nThe greatest performances don’t come from “playing” a character. They come from BEING one.\n\nThe GPS Method™ teaches you how to dissolve the gap between you and the role — so there’s nothing left to perform.\n\nJust truth.\n\nReady to make the shift? Link in bio.`,
    hashtags: "#StopActing #StartBeing #GPSMethod #ActingLife #TruthInPerformance #ActorTraining #RealActing #PerformanceCoaching #ActorsOfInstagram #MelMasry",
  },
  {
    id: 5,
    type: "education",
    headline: "WHAT MAKES GPS DIFFERENT?",
    points: [
      "Psychology-first approach to actor training",
      "Internal structure before external technique",
      "Personalised coaching, not one-size-fits-all",
      "Real-world application from day one",
      "Built for working professionals",
    ],
    caption: `What makes the GPS Method™ different from traditional actor training?\n\n1️⃣ Psychology-first approach — we start with the mind, not the monologue\n2️⃣ Internal structure before external technique\n3️⃣ Personalised coaching tailored to YOUR process\n4️⃣ Real-world application from day one\n5️⃣ Built for working professionals who want depth\n\nThis isn’t another acting class. It’s a system for transformation.\n\nApplications open — link in bio.`,
    hashtags: "#GPSMethod #ActorTraining #ActingSchool #PsychologicalPresence #CoachingSchool #ActingTechnique #ProfessionalActor #PerformanceTraining #ActorsLife #MelMasry",
  },
  {
    id: 6,
    type: "testimonial",
    headline: "“The GPS Method completely changed how I approach my craft.”",
    subline: "GPS Method Student",
    body: "After 10 years in the industry, I thought I knew my process. The GPS Method showed me how much deeper I could go. The grounding work alone transformed my audition confidence.",
    caption: `“The GPS Method completely changed how I approach my craft.”\n\nAfter 10 years in the industry, this student thought they knew their process. The GPS Method showed them how much deeper they could go.\n\n“The grounding work alone transformed my audition confidence.”\n\nReal training. Real results.\n\nApply now — link in bio.`,
    hashtags: "#GPSMethod #Testimonial #ActorTraining #StudentSuccess #ActingCoach #TransformYourCraft #AuditionConfidence #PerformanceCoaching #ActorsOfInstagram #TheatreLife",
  },
  {
    id: 7,
    type: "cta",
    headline: "APPLICATIONS NOW OPEN",
    subline: "GPS Coaching School 2026",
    body: "Limited places available for committed actors ready to transform their craft.",
    accent: "APPLY NOW →",
    bgImage: "https://images.unsplash.com/photo-1771942690809-49605caf6ec5?w=800&q=80",
    caption: `Applications are NOW OPEN for the GPS Coaching School 2026.\n\nLimited places available for committed actors who are ready to:\n\n• Build genuine psychological presence\n• Develop a structured internal process\n• Transform how they prepare and perform\n\nThis programme is application-based. Not everyone is accepted.\n\nAre you ready? Apply now — link in bio.`,
    hashtags: "#GPSMethod #ApplyNow #ActorTraining #CoachingSchool #ActingSchool #2026Training #LimitedPlaces #ActorsWanted #PerformanceCoaching #MelMasry",
  },
  {
    id: 8,
    type: "coaching",
    headline: "PRIVATE COACHING",
    subline: "One-on-One with Mel Masry",
    body: "Intensive personalised sessions for actors seeking deep, focused transformation work.",
    bgImage: "https://images.unsplash.com/photo-1633508776827-ff02c441eadf?w=800&q=80",
    caption: `Private Coaching — One-on-One with Mel Masry.\n\nFor actors who want focused, personalised guidance, private coaching offers:\n\n• Deep psychological presence work\n• Tailored to your specific challenges\n• Intensive sessions designed around YOUR craft\n• Application-based — limited availability\n\nThis is not group work. This is YOUR transformation.\n\nEnquire now — link in bio.`,
    hashtags: "#PrivateCoaching #GPSMethod #MelMasry #ActorCoaching #OneOnOne #PersonalisedTraining #ActingCoach #DeepWork #PerformanceCoaching #ActorsOfInstagram",
  },
  {
    id: 9,
    type: "pathways",
    headline: "YOUR CAREER.",
    subline: "YOUR TERMS.",
    body: "Professional pathways for actors, directors, and coaches who want to build a career with depth and purpose.",
    accent: "EXPLORE PATHWAYS",
    caption: `Your career. Your terms.\n\nThe GPS Method™ isn’t just training — it’s a launchpad for your professional journey.\n\nWhether you’re an actor, director, or aspiring coach, our professional pathways are designed to help you:\n\n• Build a sustainable creative career\n• Develop your unique artistic voice\n• Connect with industry professionals\n• Turn your training into real-world opportunity\n\nDiscover your pathway — link in bio.`,
    hashtags: "#GPSMethod #ProfessionalPathways #ActorCareer #CreativeCareer #ActingIndustry #DirectorTraining #CoachTraining #CareerDevelopment #ArtisticGrowth #TheatreProfessional",
  },
  {
    id: 10,
    type: "beforeafter",
    headline: "BEFORE GPS",
    subline: "AFTER GPS",
    beforePoints: ["Overthinking every choice", "Disconnected from the body", "Performing emotions", "Hoping it lands"],
    afterPoints: ["Trusting your instincts", "Grounded and centred", "Living the moment", "Knowing it lands"],
    caption: "Before GPS vs After GPS.\n\nBefore:\n- Overthinking every choice\n- Disconnected from the body\n- Performing emotions\n- Hoping it lands\n\nAfter:\n- Trusting your instincts\n- Grounded and centred\n- Living the moment\n- Knowing it lands\n\nThe shift is real. The GPS Method\u2122 doesn\u2019t add to your process \u2014 it transforms it from the inside out.\n\nReady for the shift? Link in bio.",
    hashtags: "#GPSMethod #BeforeAndAfter #ActorTransformation #ActingJourney #PresenceWork #TrustYourProcess #ActorTraining #PerformanceShift #GroundedActor #TheGPSWay",
  },
  {
    id: 11,
    type: "dailytip",
    tipNumber: "01",
    headline: "DAILY PRACTICE",
    subline: "Ground yourself before you begin",
    body: "Before every rehearsal, audition, or performance \u2014 take 60 seconds. Feet on the floor. Breath in the belly. Feel the weight of your body. You cannot be present if you haven\u2019t arrived.",
    caption: "GPS Daily Practice Tip #01\n\nGround yourself before you begin.\n\nBefore every rehearsal, audition, or performance \u2014 take 60 seconds.\n\nFeet on the floor.\nBreath in the belly.\nFeel the weight of your body.\n\nYou cannot be present if you haven\u2019t arrived.\n\nThis is the foundation of the GPS Method\u2122 \u2014 and it starts before a single word is spoken.\n\nSave this. Try it tomorrow.\n\nMore tips every week \u2014 follow @gps1way",
    hashtags: "#GPSMethod #DailyPractice #ActingTips #GroundingExercise #ActorPrep #AuditionTips #MindfulActor #PresenceWork #ActingCoach #TheatreTips",
  },
  {
    id: 12,
    type: "boldtext",
    headline: "TALENT IS COMMON.",
    subline: "PRESENCE IS RARE.",
    body: "That\u2019s why we train presence.",
    bgImage: "https://images.unsplash.com/photo-1774016591378-925354a456ee?w=800&q=80",
    caption: "Talent is common. Presence is rare.\n\nEvery casting room is full of talented actors. The ones who book the role? They\u2019re the ones who walk in with something more.\n\nPresence.\n\nIt\u2019s not charisma. It\u2019s not confidence. It\u2019s the ability to be fully, completely HERE \u2014 and make everyone in the room feel it.\n\nThat\u2019s what the GPS Method\u2122 trains.\n\nLink in bio.",
    hashtags: "#GPSMethod #TalentVsPresence #ActingLife #CastingRoom #AuditionTips #BookTheRole #ActorMindset #PresenceIsEverything #ActorTraining #StandOut",
  },
  {
    id: 13,
    type: "numberedlist",
    headline: "5 SIGNS YOU NEED GPS",
    items: [
      "You feel \u2018stuck\u2019 in your process and can\u2019t break through",
      "You\u2019re technically skilled but something feels missing",
      "Auditions feel like performances instead of connections",
      "You leave rehearsals feeling drained, not energised",
      "You know there\u2019s a deeper level but can\u2019t access it alone",
    ],
    caption: "5 signs you need the GPS Method\u2122:\n\n1. You feel \u2018stuck\u2019 in your process and can\u2019t break through\n2. You\u2019re technically skilled but something feels missing\n3. Auditions feel like performances instead of connections\n4. You leave rehearsals feeling drained, not energised\n5. You know there\u2019s a deeper level but can\u2019t access it alone\n\nIf even ONE of these resonates \u2014 the GPS Method was built for you.\n\nTag an actor friend who needs to see this.\n\nLearn more \u2014 link in bio.",
    hashtags: "#GPSMethod #ActorStuck #BreakThrough #ActingProcess #AuditionHelp #ActorLife #PerformanceAnxiety #ActingCoach #DeepWork #TransformYourCraft",
  },
  {
    id: 14,
    type: "quote",
    headline: "\u201CThe body knows before the mind decides. Trust it.\u201D",
    subline: "\u2014 Mel Masry",
    body: "Founder, GPS Method\u2122",
    bgImage: "https://images.unsplash.com/photo-1774016591255-10545a911cb2?w=800&q=80",
    caption: "\u201CThe body knows before the mind decides. Trust it.\u201D \u2014 Mel Masry\n\nSo much of acting training lives in the head. Analysis. Intention. Objective.\n\nBut the body is always one step ahead. It knows the truth before your conscious mind catches up.\n\nThe GPS Method\u2122 teaches you to listen to that intelligence \u2014 and let it lead.\n\nFollow for more insights \u2014 @gps1way",
    hashtags: "#GPSMethod #BodyIntelligence #ActingQuotes #MelMasry #TrustYourBody #SomaticActing #ActorWisdom #PresenceWork #MindBodyActor #PhysicalIntelligence",
  },
  {
    id: 15,
    type: "workshop",
    headline: "WORKSHOP",
    subline: "Introduction to GPS Method\u2122",
    details: ["Duration: Full Day Intensive", "Format: In-Person / Small Group", "Level: All Experience Levels", "Location: London, UK"],
    body: "Experience the fundamentals of Grounding, Presence, and Structure in a single transformative session.",
    caption: "Workshop Announcement: Introduction to GPS Method\u2122\n\nExperience the fundamentals of Grounding, Presence, and Structure in a single transformative day.\n\nDetails:\n\u2022 Full Day Intensive\n\u2022 In-Person, Small Group\n\u2022 All Experience Levels Welcome\n\u2022 London, UK\n\nThis isn\u2019t a lecture. It\u2019s an experience. You\u2019ll leave with practical tools you can use immediately in your next rehearsal or audition.\n\nLimited spaces \u2014 DM to register or visit link in bio.",
    hashtags: "#GPSMethod #ActingWorkshop #LondonActors #IntensiveTraining #ActorWorkshop #SmallGroupTraining #InPersonWorkshop #GPSIntro #ActingLondon #WorkshopAnnouncement",
  },
  {
    id: 16,
    type: "versus",
    headline: "THEY TEACH YOU",
    subline: "WHAT TO DO.",
    body2: "WE TEACH YOU",
    accent: "HOW TO BE.",
    bgImage: "https://images.unsplash.com/photo-1560381328-696dda198bae?w=800&q=80",
    caption: "They teach you what to do.\nWe teach you how to be.\n\nMost training programmes focus on actions, objectives, and tactics. Important? Yes.\n\nBut without internal presence, those tools are just mechanics.\n\nThe GPS Method\u2122 gives you the foundation that makes every technique work better \u2014 because it starts with YOU, not the character.\n\nExperience the difference \u2014 link in bio.",
    hashtags: "#GPSMethod #HowToBe #ActingPhilosophy #BeyondTechnique #InternalWork #ActorTraining #RealPresence #DeepActing #ActorsJourney #TransformativeTraining",
  },
  {
    id: 17,
    type: "testimonial",
    headline: "\u201CI walked into my audition differently. I didn\u2019t perform \u2014 I arrived.\u201D",
    subline: "GPS Method Graduate",
    body: "Three months into the programme, everything shifted. I stopped trying to \u2018show\u2019 the panel who I was and simply let them see me. I booked the role.",
    caption: "\u201CI walked into my audition differently. I didn\u2019t perform \u2014 I arrived.\u201D\n\n\u2014 GPS Method Graduate\n\nThree months into the programme, everything shifted.\n\n\u201CI stopped trying to \u2018show\u2019 the panel who I was and simply let them see me. I booked the role.\u201D\n\nThis is what real transformation looks like. Not louder. Not bigger. Just MORE PRESENT.\n\nYour transformation starts here \u2014 link in bio.",
    hashtags: "#GPSMethod #StudentTestimonial #AuditionSuccess #BookedIt #ActorWin #PresenceWorks #RealResults #ActingTransformation #GPSGraduate #ActorsOfInstagram",
  },
  {
    id: 18,
    type: "community",
    headline: "JOIN THE MOVEMENT",
    subline: "A growing community of present actors",
    stats: [
      { number: "200+", label: "Actors Trained" },
      { number: "15+", label: "Countries" },
      { number: "96%", label: "Recommend GPS" },
    ],
    caption: "Join the movement.\n\nThe GPS Method\u2122 community is growing \u2014 a network of actors, directors, and coaches from around the world who share one thing: the commitment to presence.\n\n200+ Actors Trained\n15+ Countries Represented\n96% Recommend GPS Method\u2122\n\nThis isn\u2019t just a programme. It\u2019s a community of artists who refuse to settle for surface-level work.\n\nBecome part of it \u2014 link in bio.",
    hashtags: "#GPSMethod #ActorCommunity #GlobalActors #JoinTheMovement #PresenceCommunity #ActorsUnite #GPSFamily #WorldwideActors #ActingNetwork #TheatreCommunity",
  },
];

function PostCard({ post, index }) {
  const cardRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (!cardRef.current || downloading) return;
    setDownloading(true);
    try {
      const canvas = await html2canvas(cardRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#1a1c1b",
        width: 1080,
        height: 1080,
      });
      const link = document.createElement("a");
      link.download = `gps-method-post-${index + 1}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (err) {
      console.error("Download failed:", err);
    }
    setDownloading(false);
  };

  const handleCopyCaption = () => {
    const fullText = `${post.caption}\n\n${post.hashtags}`;
    navigator.clipboard.writeText(fullText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="flex flex-col gap-4">
      {/* The visual post card */}
      <div
        ref={cardRef}
        style={{ width: 1080, height: 1080 }}
        className="origin-top-left shrink-0"
      >
        {post.type === "brand" && <BrandCard post={post} />}
        {post.type === "quote" && <QuoteCard post={post} />}
        {post.type === "pillars" && <PillarsCard post={post} />}
        {post.type === "statement" && <StatementCard post={post} />}
        {post.type === "education" && <EducationCard post={post} />}
        {post.type === "testimonial" && <TestimonialCard post={post} />}
        {post.type === "cta" && <CTACard post={post} />}
        {post.type === "coaching" && <CoachingCard post={post} />}
        {post.type === "pathways" && <PathwaysCard post={post} />}
        {post.type === "beforeafter" && <BeforeAfterCard post={post} />}
        {post.type === "dailytip" && <DailyTipCard post={post} />}
        {post.type === "boldtext" && <BoldTextCard post={post} />}
        {post.type === "numberedlist" && <NumberedListCard post={post} />}
        {post.type === "workshop" && <WorkshopCard post={post} />}
        {post.type === "versus" && <VersusCard post={post} />}
        {post.type === "community" && <CommunityCard post={post} />}
      </div>

      {/* Caption + actions */}
      <div className="flex gap-3 mt-2">
        <button
          data-testid={`download-post-${index + 1}`}
          onClick={handleDownload}
          disabled={downloading}
          className="px-5 py-2.5 text-sm font-bold uppercase tracking-wider"
          style={{
            background: "#d9fb06",
            color: "#1a1c1b",
            border: "none",
            cursor: downloading ? "wait" : "pointer",
            opacity: downloading ? 0.6 : 1,
          }}
        >
          {downloading ? "Generating..." : "Download PNG"}
        </button>
        <button
          data-testid={`copy-caption-${index + 1}`}
          onClick={handleCopyCaption}
          className="px-5 py-2.5 text-sm font-bold uppercase tracking-wider"
          style={{
            background: "transparent",
            color: "#d9fb06",
            border: "1px solid #d9fb06",
            cursor: "pointer",
          }}
        >
          {copied ? "Copied!" : "Copy Caption"}
        </button>
      </div>

      {/* Caption preview */}
      <div
        className="p-4 text-sm leading-relaxed whitespace-pre-line"
        style={{ background: "#302f2c", color: "#dfddd6", maxWidth: 1080 }}
      >
        <p>{post.caption}</p>
        <p className="mt-3 text-xs" style={{ color: "#888680" }}>
          {post.hashtags}
        </p>
      </div>
    </div>
  );
}

/* ============================================
   INDIVIDUAL CARD DESIGNS (1080x1080)
   ============================================ */

function BrandCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: 100,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative elements */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 6,
          background: "#d9fb06",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: 6,
          background: "#d9fb06",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 60,
          right: 100,
          width: 200,
          height: 200,
          border: "2px solid rgba(217,251,6,0.15)",
          borderRadius: "50%",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 120,
          right: 60,
          width: 120,
          height: 120,
          border: "2px solid rgba(217,251,6,0.1)",
          borderRadius: "50%",
        }}
      />

      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 900,
          fontSize: 110,
          color: "#d9fb06",
          lineHeight: 0.95,
          letterSpacing: "-0.03em",
        }}
      >
        GPS
        <br />
        METHOD™
      </div>
      <div
        style={{
          width: 80,
          height: 4,
          background: "#d9fb06",
          marginTop: 40,
          marginBottom: 40,
        }}
      />
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 400,
          fontSize: 32,
          color: "#dfddd6",
          letterSpacing: "0.05em",
        }}
      >
        {post.subline}
      </div>
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 300,
          fontSize: 22,
          color: "#888680",
          marginTop: 20,
        }}
      >
        {post.body}
      </div>
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 300,
          fontSize: 18,
          color: "#888680",
          marginTop: 8,
        }}
      >
        {post.accent}
      </div>
    </div>
  );
}

function QuoteCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {post.bgImage && (
        <img
          src={post.bgImage}
          alt=""
          crossOrigin="anonymous"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.15,
          }}
        />
      )}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(180deg, rgba(26,28,27,0.8) 0%, rgba(26,28,27,0.95) 100%)",
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "100%",
          padding: 100,
        }}
      >
        <div
          style={{
            fontFamily: "Georgia, serif",
            fontSize: 160,
            color: "#d9fb06",
            lineHeight: 0.5,
            marginBottom: 30,
            opacity: 0.6,
          }}
        >
          “
        </div>
        <div
          style={{
            fontFamily: "Georgia, serif",
            fontWeight: 400,
            fontSize: 48,
            color: "#dfddd6",
            lineHeight: 1.4,
            fontStyle: "italic",
          }}
        >
          Presence is not something you perform. It is something you inhabit.
        </div>
        <div
          style={{
            width: 60,
            height: 3,
            background: "#d9fb06",
            marginTop: 50,
            marginBottom: 30,
          }}
        />
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 600,
            fontSize: 24,
            color: "#d9fb06",
          }}
        >
          {post.subline}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 18,
            color: "#888680",
            marginTop: 8,
          }}
        >
          {post.body}
        </div>
      </div>
    </div>
  );
}

function PillarsCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        display: "flex",
        flexDirection: "column",
        padding: 80,
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 6,
          background: "#d9fb06",
        }}
      />
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 300,
          fontSize: 18,
          color: "#888680",
          letterSpacing: "0.3em",
          textTransform: "uppercase",
          marginBottom: 20,
        }}
      >
        {post.headline}
      </div>
      <div
        style={{
          display: "flex",
          flex: 1,
          gap: 40,
          alignItems: "center",
        }}
      >
        {post.pillars.map((p, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              padding: "20px 10px",
              borderLeft: i > 0 ? "1px solid rgba(217,251,6,0.15)" : "none",
            }}
          >
            <div
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                fontWeight: 900,
                fontSize: 140,
                color: "#d9fb06",
                lineHeight: 1,
                marginBottom: 20,
              }}
            >
              {p.letter}
            </div>
            <div
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                fontWeight: 700,
                fontSize: 22,
                color: "#dfddd6",
                letterSpacing: "0.15em",
                marginBottom: 20,
              }}
            >
              {p.word}
            </div>
            <div
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                fontWeight: 300,
                fontSize: 16,
                color: "#888680",
                lineHeight: 1.6,
              }}
            >
              {p.desc}
            </div>
          </div>
        ))}
      </div>
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 600,
          fontSize: 16,
          color: "#d9fb06",
          letterSpacing: "0.2em",
          textAlign: "center",
          marginTop: 20,
        }}
      >
        GPS METHOD™
      </div>
    </div>
  );
}

function StatementCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {post.bgImage && (
        <img
          src={post.bgImage}
          alt=""
          crossOrigin="anonymous"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.2,
          }}
        />
      )}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(135deg, rgba(26,28,27,0.9) 0%, rgba(26,28,27,0.7) 100%)",
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          textAlign: "center",
          padding: 80,
        }}
      >
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 900,
            fontSize: 96,
            color: "#dfddd6",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
          }}
        >
          {post.headline}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 900,
            fontSize: 96,
            color: "#d9fb06",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
          }}
        >
          {post.subline}
        </div>
        <div
          style={{
            width: 80,
            height: 3,
            background: "#d9fb06",
            marginTop: 50,
            marginBottom: 30,
          }}
        />
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 24,
            color: "#888680",
          }}
        >
          {post.body}
        </div>
      </div>
    </div>
  );
}

function EducationCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: 100,
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: 300,
          height: 300,
          background: "radial-gradient(circle, rgba(217,251,6,0.06) 0%, transparent 70%)",
        }}
      />
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 900,
          fontSize: 52,
          color: "#d9fb06",
          lineHeight: 1.1,
          marginBottom: 60,
        }}
      >
        {post.headline}
      </div>
      {post.points.map((point, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 24,
            marginBottom: 32,
          }}
        >
          <div
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontWeight: 800,
              fontSize: 28,
              color: "#d9fb06",
              width: 50,
              flexShrink: 0,
            }}
          >
            0{i + 1}
          </div>
          <div
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontWeight: 400,
              fontSize: 26,
              color: "#dfddd6",
              lineHeight: 1.4,
              borderBottom: "1px solid rgba(217,251,6,0.1)",
              paddingBottom: 20,
              flex: 1,
            }}
          >
            {point}
          </div>
        </div>
      ))}
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 600,
          fontSize: 16,
          color: "#d9fb06",
          letterSpacing: "0.2em",
          marginTop: 30,
        }}
      >
        GPS METHOD™
      </div>
    </div>
  );
}

function TestimonialCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#302f2c",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: 100,
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 6,
          height: "100%",
          background: "#d9fb06",
        }}
      />
      <div
        style={{
          fontFamily: "Georgia, serif",
          fontSize: 120,
          color: "#d9fb06",
          lineHeight: 0.5,
          marginBottom: 20,
          opacity: 0.4,
        }}
      >
        “
      </div>
      <div
        style={{
          fontFamily: "Georgia, serif",
          fontStyle: "italic",
          fontSize: 42,
          color: "#dfddd6",
          lineHeight: 1.4,
          marginBottom: 40,
        }}
      >
        {post.headline.replace(/“|”/g, "")}
      </div>
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 300,
          fontSize: 22,
          color: "#888680",
          lineHeight: 1.6,
          marginBottom: 50,
        }}
      >
        {post.body}
      </div>
      <div
        style={{
          width: 60,
          height: 3,
          background: "#d9fb06",
          marginBottom: 20,
        }}
      />
      <div
        style={{
          fontFamily: "Inter, Arial, sans-serif",
          fontWeight: 600,
          fontSize: 20,
          color: "#d9fb06",
        }}
      >
        — {post.subline}
      </div>
    </div>
  );
}

function CTACard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {post.bgImage && (
        <img
          src={post.bgImage}
          alt=""
          crossOrigin="anonymous"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.12,
          }}
        />
      )}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(180deg, rgba(26,28,27,0.6) 0%, rgba(26,28,27,0.95) 100%)",
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          textAlign: "center",
          padding: 80,
        }}
      >
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 18,
            color: "#888680",
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            marginBottom: 30,
          }}
        >
          {post.subline}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 900,
            fontSize: 80,
            color: "#d9fb06",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            marginBottom: 40,
          }}
        >
          {post.headline}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 24,
            color: "#dfddd6",
            lineHeight: 1.5,
            maxWidth: 700,
            marginBottom: 60,
          }}
        >
          {post.body}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 22,
            color: "#1a1c1b",
            background: "#d9fb06",
            padding: "20px 60px",
            letterSpacing: "0.1em",
          }}
        >
          {post.accent}
        </div>
      </div>
    </div>
  );
}

function CoachingCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {post.bgImage && (
        <img
          src={post.bgImage}
          alt=""
          crossOrigin="anonymous"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.18,
          }}
        />
      )}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to right, rgba(26,28,27,0.95) 0%, rgba(26,28,27,0.7) 100%)",
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "100%",
          padding: 100,
        }}
      >
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 16,
            color: "#888680",
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            marginBottom: 20,
          }}
        >
          Exclusive Programme
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 900,
            fontSize: 72,
            color: "#d9fb06",
            lineHeight: 1.05,
            marginBottom: 20,
          }}
        >
          {post.headline}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 400,
            fontSize: 30,
            color: "#dfddd6",
            marginBottom: 40,
          }}
        >
          {post.subline}
        </div>
        <div
          style={{
            width: 60,
            height: 3,
            background: "#d9fb06",
            marginBottom: 30,
          }}
        />
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 22,
            color: "#888680",
            lineHeight: 1.6,
            maxWidth: 600,
          }}
        >
          {post.body}
        </div>
      </div>
    </div>
  );
}

function PathwaysCard({ post }) {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        background: "#1a1c1b",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: 100,
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "radial-gradient(ellipse at center, rgba(217,251,6,0.04) 0%, transparent 60%)",
        }}
      />
      <div style={{ position: "relative", zIndex: 1 }}>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 900,
            fontSize: 88,
            color: "#dfddd6",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
          }}
        >
          {post.headline}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 900,
            fontSize: 88,
            color: "#d9fb06",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            marginBottom: 50,
          }}
        >
          {post.subline}
        </div>
        <div
          style={{
            width: 80,
            height: 3,
            background: "#d9fb06",
            margin: "0 auto 40px",
          }}
        />
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 24,
            color: "#888680",
            lineHeight: 1.6,
            maxWidth: 700,
            margin: "0 auto 50px",
          }}
        >
          {post.body}
        </div>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 800,
            fontSize: 20,
            color: "#1a1c1b",
            background: "#d9fb06",
            padding: "18px 50px",
            display: "inline-block",
            letterSpacing: "0.1em",
          }}
        >
          {post.accent}
        </div>
      </div>
    </div>
  );
}

function BeforeAfterCard({ post }) {
  return (
    <div style={{ width: 1080, height: 1080, background: "#1a1c1b", display: "flex", position: "relative" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 6, background: "#d9fb06" }} />
      {/* Before side */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: "80px 60px", borderRight: "1px solid rgba(217,251,6,0.15)" }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 14, color: "#888680", letterSpacing: "0.3em", marginBottom: 20 }}>BEFORE</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 42, color: "#888680", lineHeight: 1.1, marginBottom: 40 }}>{post.headline}</div>
        {post.beforePoints.map((p, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24 }}>
            <div style={{ width: 8, height: 8, background: "#888680", borderRadius: "50%", flexShrink: 0 }} />
            <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 20, color: "#888680" }}>{p}</div>
          </div>
        ))}
      </div>
      {/* After side */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: "80px 60px" }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 14, color: "#d9fb06", letterSpacing: "0.3em", marginBottom: 20 }}>AFTER</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 42, color: "#d9fb06", lineHeight: 1.1, marginBottom: 40 }}>{post.subline}</div>
        {post.afterPoints.map((p, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24 }}>
            <div style={{ width: 8, height: 8, background: "#d9fb06", borderRadius: "50%", flexShrink: 0 }} />
            <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 400, fontSize: 20, color: "#dfddd6" }}>{p}</div>
          </div>
        ))}
      </div>
      <div style={{ position: "absolute", bottom: 40, left: 0, right: 0, textAlign: "center", fontFamily: "Inter, Arial, sans-serif", fontWeight: 600, fontSize: 14, color: "#d9fb06", letterSpacing: "0.2em" }}>GPS METHOD™</div>
    </div>
  );
}

function DailyTipCard({ post }) {
  return (
    <div style={{ width: 1080, height: 1080, background: "#1a1c1b", display: "flex", flexDirection: "column", justifyContent: "center", padding: 100, position: "relative" }}>
      <div style={{ position: "absolute", top: 0, left: 0, width: 6, height: "100%", background: "#d9fb06" }} />
      <div style={{ display: "flex", alignItems: "baseline", gap: 16, marginBottom: 30 }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 72, color: "#d9fb06", lineHeight: 1 }}>#{post.tipNumber}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 16, color: "#888680", letterSpacing: "0.3em", textTransform: "uppercase" }}>{post.headline}</div>
      </div>
      <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 700, fontSize: 38, color: "#dfddd6", lineHeight: 1.2, marginBottom: 40 }}>{post.subline}</div>
      <div style={{ width: 60, height: 3, background: "#d9fb06", marginBottom: 30 }} />
      <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 24, color: "#888680", lineHeight: 1.7 }}>{post.body}</div>
      <div style={{ position: "absolute", bottom: 60, right: 100, fontFamily: "Inter, Arial, sans-serif", fontWeight: 600, fontSize: 14, color: "#d9fb06", letterSpacing: "0.2em" }}>GPS METHOD™</div>
    </div>
  );
}

function BoldTextCard({ post }) {
  return (
    <div style={{ width: 1080, height: 1080, background: "#1a1c1b", position: "relative", overflow: "hidden" }}>
      {post.bgImage && (
        <img src={post.bgImage} alt="" crossOrigin="anonymous" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: 0.12 }} />
      )}
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(26,28,27,0.85) 0%, rgba(26,28,27,0.95) 100%)" }} />
      <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", textAlign: "center", padding: 80 }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 72, color: "#dfddd6", lineHeight: 1.15, letterSpacing: "-0.02em" }}>{post.headline}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 72, color: "#d9fb06", lineHeight: 1.15, letterSpacing: "-0.02em", marginBottom: 40 }}>{post.subline}</div>
        <div style={{ width: 60, height: 3, background: "#d9fb06", marginBottom: 30 }} />
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 26, color: "#888680" }}>{post.body}</div>
      </div>
    </div>
  );
}

function NumberedListCard({ post }) {
  return (
    <div style={{ width: 1080, height: 1080, background: "#1a1c1b", display: "flex", flexDirection: "column", justifyContent: "center", padding: 100, position: "relative" }}>
      <div style={{ position: "absolute", top: 0, right: 0, width: 400, height: 400, background: "radial-gradient(circle, rgba(217,251,6,0.05) 0%, transparent 70%)" }} />
      <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 48, color: "#d9fb06", lineHeight: 1.1, marginBottom: 50 }}>{post.headline}</div>
      {post.items.map((item, i) => (
        <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 20, marginBottom: 28 }}>
          <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 800, fontSize: 32, color: "#d9fb06", width: 50, flexShrink: 0, lineHeight: 1 }}>{i + 1}.</div>
          <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 400, fontSize: 22, color: "#dfddd6", lineHeight: 1.4, borderBottom: "1px solid rgba(217,251,6,0.08)", paddingBottom: 18, flex: 1 }}>{item}</div>
        </div>
      ))}
      <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 600, fontSize: 14, color: "#d9fb06", letterSpacing: "0.2em", marginTop: 20 }}>GPS METHOD™</div>
    </div>
  );
}

function WorkshopCard({ post }) {
  return (
    <div style={{ width: 1080, height: 1080, background: "#1a1c1b", display: "flex", flexDirection: "column", position: "relative" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 6, background: "#d9fb06" }} />
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 6, background: "#d9fb06" }} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: 100 }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 16, color: "#888680", letterSpacing: "0.4em", textTransform: "uppercase", marginBottom: 16 }}>Announcement</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 80, color: "#d9fb06", lineHeight: 1, marginBottom: 16 }}>{post.headline}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 400, fontSize: 28, color: "#dfddd6", marginBottom: 40 }}>{post.subline}</div>
        <div style={{ width: 60, height: 3, background: "#d9fb06", marginBottom: 40 }} />
        {post.details.map((d, i) => (
          <div key={i} style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 400, fontSize: 20, color: "#888680", marginBottom: 14, display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 6, height: 6, background: "#d9fb06", borderRadius: "50%" }} />
            {d}
          </div>
        ))}
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 20, color: "#dfddd6", lineHeight: 1.6, marginTop: 30 }}>{post.body}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 800, fontSize: 18, color: "#1a1c1b", background: "#d9fb06", padding: "16px 40px", display: "inline-block", marginTop: 40, letterSpacing: "0.1em", alignSelf: "flex-start" }}>REGISTER NOW</div>
      </div>
    </div>
  );
}

function VersusCard({ post }) {
  return (
    <div style={{ width: 1080, height: 1080, background: "#1a1c1b", position: "relative", overflow: "hidden" }}>
      {post.bgImage && (
        <img src={post.bgImage} alt="" crossOrigin="anonymous" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: 0.1 }} />
      )}
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(26,28,27,0.95) 0%, rgba(26,28,27,0.8) 100%)" }} />
      <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", textAlign: "center", padding: 80 }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 36, color: "#888680", marginBottom: 8 }}>{post.headline}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 80, color: "#888680", lineHeight: 1.1, marginBottom: 40, opacity: 0.5 }}>{post.subline}</div>
        <div style={{ width: 80, height: 2, background: "#d9fb06", marginBottom: 40 }} />
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 36, color: "#d9fb06", marginBottom: 8 }}>{post.body2}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 80, color: "#d9fb06", lineHeight: 1.1 }}>{post.accent}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 600, fontSize: 14, color: "#d9fb06", letterSpacing: "0.2em", marginTop: 60 }}>GPS METHOD™</div>
      </div>
    </div>
  );
}

function CommunityCard({ post }) {
  return (
    <div style={{ width: 1080, height: 1080, background: "#1a1c1b", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", padding: 100, position: "relative" }}>
      <div style={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse at center, rgba(217,251,6,0.05) 0%, transparent 55%)" }} />
      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 64, color: "#d9fb06", lineHeight: 1.1, marginBottom: 16 }}>{post.headline}</div>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 22, color: "#888680", marginBottom: 60 }}>{post.subline}</div>
        <div style={{ display: "flex", gap: 60, justifyContent: "center", marginBottom: 60 }}>
          {post.stats.map((s, i) => (
            <div key={i}>
              <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 56, color: "#d9fb06", lineHeight: 1 }}>{s.number}</div>
              <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 16, color: "#888680", marginTop: 8, letterSpacing: "0.1em" }}>{s.label}</div>
            </div>
          ))}
        </div>
        <div style={{ width: 60, height: 3, background: "#d9fb06", margin: "0 auto 30px" }} />
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 800, fontSize: 18, color: "#1a1c1b", background: "#d9fb06", padding: "18px 50px", display: "inline-block", letterSpacing: "0.1em" }}>JOIN NOW</div>
      </div>
    </div>
  );
}


export default function InstagramContent() {
  const [downloadingAll, setDownloadingAll] = useState(false);

  return (
    <div
      data-testid="instagram-content-page"
      style={{ background: "#1a1c1b", minHeight: "100vh", padding: "120px 40px 80px" }}
    >
      {/* Header */}
      <div style={{ maxWidth: 1200, margin: "0 auto 60px" }}>
        <div
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 300,
            fontSize: 14,
            color: "#888680",
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            marginBottom: 16,
          }}
        >
          Content Studio
        </div>
        <h1
          className="brand-display"
          style={{ fontSize: "clamp(2.5rem, 4vw, 5rem)", marginBottom: 20 }}
        >
          INSTAGRAM POSTS
        </h1>
        <p style={{ color: "#888680", fontSize: 18, maxWidth: 600, lineHeight: 1.6 }}>
          {POSTS.length} ready-to-post branded cards for your GPS Method™ Instagram.
          Download each as a high-res PNG and copy the caption + hashtags.
        </p>
      </div>

      {/* Posts grid - scaled down for preview */}
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {POSTS.map((post, i) => (
          <div
            key={post.id}
            style={{
              marginBottom: 80,
              paddingBottom: 80,
              borderBottom: "1px solid rgba(217,251,6,0.1)",
            }}
          >
            <div
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                fontWeight: 700,
                fontSize: 14,
                color: "#d9fb06",
                letterSpacing: "0.2em",
                marginBottom: 20,
              }}
            >
              POST {String(i + 1).padStart(2, "0")} / {String(POSTS.length).padStart(2, "0")}
            </div>

            {/* Scaled preview wrapper */}
            <div
              style={{
                width: "100%",
                maxWidth: 540,
                aspectRatio: "1 / 1",
                overflow: "hidden",
                border: "1px solid rgba(217,251,6,0.15)",
              }}
            >
              <div
                style={{
                  transform: "scale(0.5)",
                  transformOrigin: "top left",
                  width: 1080,
                  height: 1080,
                }}
              >
                <PostCard post={post} index={i} />
              </div>
            </div>

            {/* Actions below the scaled preview */}
            <div style={{ maxWidth: 540, marginTop: 16 }}>
              <DownloadAndCaption post={post} index={i} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function DownloadAndCaption({ post, index }) {
  const cardRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (downloading) return;
    setDownloading(true);

    // Create a hidden full-size render for download
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.top = "-9999px";
    container.style.left = "-9999px";
    container.style.width = "1080px";
    container.style.height = "1080px";
    document.body.appendChild(container);

    // Render the card type
    const { createRoot } = await import("react-dom/client");
    const root = createRoot(container);

    const CardComponent = {
      brand: BrandCard,
      quote: QuoteCard,
      pillars: PillarsCard,
      statement: StatementCard,
      education: EducationCard,
      testimonial: TestimonialCard,
      cta: CTACard,
      coaching: CoachingCard,
      pathways: PathwaysCard,
      beforeafter: BeforeAfterCard,
      dailytip: DailyTipCard,
      boldtext: BoldTextCard,
      numberedlist: NumberedListCard,
      workshop: WorkshopCard,
      versus: VersusCard,
      community: CommunityCard,
    }[post.type];

    root.render(<CardComponent post={post} />);

    // Wait for images to load
    await new Promise((r) => setTimeout(r, 500));

    try {
      const canvas = await html2canvas(container, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#1a1c1b",
        width: 1080,
        height: 1080,
      });
      const link = document.createElement("a");
      link.download = `gps-method-post-${index + 1}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (err) {
      console.error("Download failed:", err);
    }

    root.unmount();
    document.body.removeChild(container);
    setDownloading(false);
  };

  const handleCopyCaption = () => {
    const fullText = `${post.caption}\n\n${post.hashtags}`;
    navigator.clipboard.writeText(fullText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div>
      <div className="flex gap-3 mb-4">
        <button
          data-testid={`download-post-${index + 1}`}
          onClick={handleDownload}
          disabled={downloading}
          style={{
            background: "#d9fb06",
            color: "#1a1c1b",
            border: "none",
            padding: "10px 24px",
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 700,
            fontSize: 13,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            cursor: downloading ? "wait" : "pointer",
            opacity: downloading ? 0.6 : 1,
          }}
        >
          {downloading ? "Generating..." : "Download PNG"}
        </button>
        <button
          data-testid={`copy-caption-${index + 1}`}
          onClick={handleCopyCaption}
          style={{
            background: "transparent",
            color: "#d9fb06",
            border: "1px solid #d9fb06",
            padding: "10px 24px",
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 700,
            fontSize: 13,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          {copied ? "Copied!" : "Copy Caption"}
        </button>
      </div>
      <div
        style={{
          background: "#302f2c",
          padding: 20,
          fontSize: 14,
          color: "#dfddd6",
          lineHeight: 1.7,
          whiteSpace: "pre-line",
        }}
      >
        <p>{post.caption}</p>
        <p style={{ marginTop: 12, fontSize: 12, color: "#888680" }}>{post.hashtags}</p>
      </div>
    </div>
  );
}
